<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="-1"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>

  <v-dialog v-model="approveRejectSaleDialog" persistent max-width="500">
    <template>
      <v-card>
        <v-card-title class="headline accent&#45;&#45;text">Sale Date</v-card-title>
        <v-card-text v-if="approveStatus === 1">Do you want to approve the sale date? </v-card-text>
        <v-card-text v-if="approveStatus === 0">Do you want to reject the sale date? </v-card-text>
        <v-card-actions>
          <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="approveRejectSaleDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="approveStatus === 1" color="secondary"  @click="approveSaleDate">Approve</v-btn>
          <v-btn v-if="approveStatus === 0" color="secondary"  @click="approveSaleDate">Reject</v-btn>
          <v-progress-circular
            style="margin-left: 10px"
            v-show="approve_loader"
            color="red"
            size="20"
            indeterminate
          ></v-progress-circular>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>

  <v-dialog v-model="approveRejectAllSaleDialog" persistent max-width="500">
    <template>
      <v-card>
        <v-card-title class="headline accent&#45;&#45;text">Sale Dates</v-card-title>
        <v-card-text>Approve/Reject all sale dates </v-card-text>
        <v-card-actions>
          <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="cancelApproveSaleDates() ">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary"  @click="approveAllSaleDate(1)">Approve</v-btn>
          <v-btn color="warning"  @click="approveAllSaleDate(0)">Reject</v-btn>
          <v-progress-circular
            style="margin-left: 10px"
            v-show="approve_loader"
            color="red"
            size="20"
            indeterminate
          ></v-progress-circular>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>

  <v-dialog v-model="editSaleDialog" persistent max-width="850">
    <template>
      <v-card>
        <v-card-title class="headline accent&#45;&#45;text"
        >Update Sale Date</v-card-title
        >
        <v-card-text>
          <v-container grid-list-xl fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout wrap>

                <v-flex xs3>
                  <label for="contractstartdate">Sale Date</label>
<!--                  <datepicker v-model="edit_start_date" id="contractstartdate" format="yyyy-MM-dd"></datepicker>-->
<!--                  <input
                    type="date"
                    id="datepicker"
                    label="Sale Date"
                    v-model="sale_date"
                    :min="this.sale_start_date_min"
                    @change="checkDate($event, 'sale_date')"
                  />-->
                  <input
                    type="date"
                    id="datepicker"
                    label="Sale Date"
                    v-model="sale_date"
                    :min="this.sale_start_date_min2"
                    @change="checkDate($event, 'sale_date')"
                  />
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="white"
            class="accentd&#45;&#45;text"
            style="font-weight: 700"
            @click="editSaleDialog = false"
          >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="updateSaleDate"
          >Submit</v-btn
          >
          <v-progress-circular
            style="margin-left: 10px"
            v-show="update_loader"
            color="red"
            size="20"
            indeterminate
          ></v-progress-circular>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
  <v-layout class="main-layout">
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex xs3>
            <span class="accent--text" style="font-size: 14px; font-weight:700;"> Sale Dates </span>
            <v-spacer v-if="userId"></v-spacer>
          </v-flex>

        </v-layout>
        <v-container grid-list-xl fluid v-if="canCreateTimeline">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs2>
                <v-text-field
                  label="Sale #"
                  min="1"
                  type="number"
                  v-model="sale_number"
                  :error-messages="saleNumberErrorMessages"
                  @input="validateSaleNumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
<!--                <v-text-field
                  label="Sale Season"
                  min="1"
                  type="number"
                  v-model="sale_season"
                  :error-messages="seasonErrorMessages"
                  @input="validateSeason"
                ></v-text-field>-->
                <v-select style="margin-top: 10px"
                  label="Seasons"
                  item-text="name"
                  item-value="value"
                  v-model="sale_season"
                  :items="seasons"
                  variant="solo-filled"
                  @change="onChangeSelect"
                  solo
                  hide-details
                  return-object
                  dense
                ></v-select>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  label="Sale Interval"
                  min="1"
                  type="number"
                  v-model="sale_interval"
                  :error-messages="intervalErrorMessages"
                  @input="validateInterval"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <label for="contractstartdate">Sale Start Date</label>
                <input
                  type="date"
                  id="datepicker"
                  label="Units"
                  v-model="sale_start_date"
                  :min="this.sale_start_date_min2"
                  @input="validateEndDate"
                  @change="checkDate($event, 'start_date')"
                />
<!--                <datepicker
                  v-model="sale_start_date"
                  validate
                  id="contractenddate"
                  format="yyyy-MM-dd">
                </datepicker>-->
              </v-flex>
              <v-flex xs2>
                <label for="contractstartdate">Sale End Date</label>
                <input
                  type="date"
                  id="datepicker"
                  label="Units"
                  v-model="sale_end_date"
                  :min="this.sale_start_date_min2"
                  @change="checkDate($event, 'end_date')"
                />
              </v-flex>
              <v-flex xs2>
                <v-btn color="#7BC243" @click="submitSale()" class="white--text cataloguebtn">Submit </v-btn>
                <v-progress-circular
                  style="margin-left: 10px"
                  v-show="create_loader"
                  color="red"
                  size="20"
                  indeterminate
                ></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <br/>
        <v-flex xs3 v-if="canUpdateTimeline">
          <v-checkbox
            v-model="checked"
            label="Approve all sale dates"
            @click.prevent="approveAllSaledates"
          ></v-checkbox>
        </v-flex>
        <v-data-table
          :headers="headers"
          :items="saleDates"
          :items-per-page="5"
          :search="search"
          class="elevation-1"
        >
<!--          <template v-slot:item.actions="{ item }">
            <v-btn
              class="btn"
              @click="editSaleDate(item)"
              color="primary">
              Edit
            </v-btn>

          </template>-->
          <template v-slot:item.actions="{ item }" >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  v-on="on"
                  text
                  icon
                  
                >
                  <v-icon small> more_horiz </v-icon>
                </v-btn>
              </template>
              <v-list v-if="item['status']['statusName'] !== 'REJECTED' && item['status']['statusName'] !== 'DISABLED'">
<!--              <v-list v-if="canCreateTimeline || canUpdateTimeline">-->
<!--              <v-list>-->
                <v-list-item v-if="canCreateTimeline && item['organisationType']['name'] === organisationType">
                  <v-list-item-title style="cursor: pointer" @click="editSaleDate(item)">Edit</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canUpdateTimeline && item['organisationType']['name'] === organisationType && item['status']['statusName'] === 'PENDING_APPROVAL'">
                  <v-list-item-title style="cursor: pointer" @click="approveRejectDefaultSlaShowDialog(item, 1)"> Approve </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="canUpdateTimeline && item['organisationType']['name'] === organisationType && item['status']['statusName'] === 'PENDING_APPROVAL'">
                  <v-list-item-title style="cursor: pointer" @click="approveRejectDefaultSlaShowDialog(item, 0)"> Reject </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>

  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			millingCharges: [],
			editSaleDialog: false,
			checked: false,
			saleDates: [],
			create_loader: false,
			update_loader: false,
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			sale_number: '',
			sale_start_date: '',
			sale_start_date_min: '',
			sale_start_date_min2: '',
			sale_start_date_max: '',
			sale_end_date_min: '',
			sale_interval: '',
			sale_end_date: '',
			sale_season: '',
			edit_sale_number: '',
			edit_interval: '',
			approveRejectSaleDialog: false,
			approveRejectAllSaleDialog: false,
			edit_season: '',
			edit_start_date: null,
			edit_end_date: null,
			currentYear: new Date(),
			saleNumberErrorMessages: [],
			startDateErrorMessages: [],
			intervalErrorMessages: [],
			endDateErrorMessages: [],
			seasonErrorMessages: [],
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'Sale Number', value: 'saleNumber' },
				{ text: 'Season', value: 'season' },
				{ text: 'Sale Date', value: 'saleDate' },
				{ text: 'Interval', value: 'interval' },
				{ text: 'Status', value: 'status.statusName' },
				{ text: 'Actions', value: 'actions', sortable: false }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0,
			organisationType: null,
			sale: '',
			sales: [],
			season: '',
			seasons: [],
			approveStatus: 0,
			sale_id: 0,
			sale_date: '',
			approve_loader: false
		}
	},
	mounted () {
		// this.getWarehouseReport()
		this.getSeasons()
		this.getSaleDates()
		this.permissions = store.state.user.roleId.permissions
		const month = ('0' + (this.currentYear.getMonth() + 1)).slice(-2)
		const day = ('0' + this.currentYear.getDate()).slice(-2)
		this.sale_start_date_min = this.currentYear.getFullYear() + '-' + month + '-' + day
		this.sale_start_date_min2 = this.currentYear.getFullYear() + '-' + month + '-' + day
		this.sale_start_date_max = this.currentYear.getFullYear() + '-10-01'
		console.log('sale_start_date_min - ', this.sale_start_date_min2)
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		canCreateTimeline: function () {
			return this.hasPerm('CAN_CREATE_TIMELINE')
		},
		canUpdateTimeline: function () {
			return this.hasPerm('CAN_UPDATE_TIMELINE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				this.organisationType = this.user.organisation.organisationType.name
				this.userID = this.user.id
				console.log('user2 - ', this.organisationType)
				return this.user.id
			}
			return 0
		}
	},
	methods: {
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		checkDate (event, dte) {
			console.log('hello')
			const date = new Date(event.target.value)
			if (date.getDay() === 0 || date.getDay() === 6) { // 0 = Sunday, 6 = Saturday
				console.log('hello2')
				alert('Weekends are not allowed.')
				this.selectedDate = ''
				event.target.value = ''
				if (dte === 'start_date') {
					this.sale_start_date = ''
				} else if (dte === 'end_date') {
					this.sale_end_date = ''
				} else if (dte === 'sale_date') {
					this.sale_date = ''
				}
			} else {
				console.log('hello3')
				this.selectedDate = event.target.value
			}
		},
		onChangeSelect (value) {
			const year = this.currentYear.getFullYear()
			const selectedYear = value.split('/')[0]
			console.log('Year:', year)
			console.log('Selected option:', value, selectedYear)
			if (selectedYear === year.toString()) {
				const month = ('0' + (this.currentYear.getMonth() + 1)).slice(-2)
				const day = ('0' + this.currentYear.getDate()).slice(-2)
				this.sale_start_date_min = this.currentYear.getFullYear() + '-' + month + '-' + day
				this.sale_start_date_max = this.currentYear.getFullYear() + '-10-01'
			} else {
				console.log('two')
				this.sale_start_date_min = this.currentYear.getFullYear() + '-10-01'
				this.sale_start_date_max = (this.currentYear.getFullYear() + 1) + '-09-30'
				// this.sale_end_date_min = (this.currentYear.getFullYear() + 1) + '-09-30'
			}
			// You can access the selected value directly using the value parameter
		},
		approveAllSaledates (event) {
			event.preventDefault()
			// this.checked = false
			this.approveRejectAllSaleDialog = true
			// this.checked = false
		},
		cancelApproveSaleDates () {
			this.checked = false
			this.approveRejectAllSaleDialog = false
			this.checked = false
		},
		editSaleDate (item) {
			console.log('--> ', item)
			this.editSaleDialog = true
			this.sale_id = item.id
			this.edit_sale_number = item.saleNumber
			this.edit_season = item.season
			this.edit_interval = item.interval
			this.edit_start_date = this.formatDate(item.startDate)
			this.edit_end_date = this.formatDate(item.endDate)
		},
		approveSaleDate () {
			this.approve_loader = true
			var url = config.serverURI + '/saledate/approveSaleDate?id=' + this.sale_id + '&status=' + this.approveStatus
			axios
				.put(url, {})
				.then(response => {
					this.approve_loader = false
					const message = response.data.body.message
					console.log('timer44---', message)
					this.create_loader = false
					this.approveRejectSaleDialog = false
					if (message === 'Success') {
						this.sale_number = ''
						this.seasons.length = 0
						this.sale_season = ''
						this.org_type = ''
						this.org_code = ''
						this.duration = ''
						this.file_type = ''

						let msg = 'Successfully approved sale date'
						if (this.approveStatus === 0) {
							msg = 'Successfully rejected sale date'
						}

						this.getSaleDates()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = msg

						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					this.approve_loader = false
					this.approveRejectSaleDialog = false
					this.message = 'Something went wrong, please try again'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		approveAllSaleDate (status) {
			this.approve_loader = true
			var url = config.serverURI + '/saledate/approveAllSaleDate?status=' + status
			axios
				.put(url, {})
				.then(response => {
					this.approve_loader = false
					const message = response.data.body.message
					console.log('timer44---', message)
					this.create_loader = false
					this.approveRejectAllSaleDialog = false
					if (message === 'Success') {
						this.sale_number = ''
						this.seasons.length = 0
						this.sale_season = ''
						this.org_type = ''
						this.org_code = ''
						this.duration = ''
						this.file_type = ''

						let msg = 'Successfully approved all sale dates'
						if (status === 0) {
							msg = 'Successfully rejected all sale dates'
						}

						this.getSaleDates()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = msg

						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					this.approve_loader = false
					this.approveRejectAllSaleDialog = false
					this.message = 'Something went wrong, please try again'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getSaleDates () {
			http.get(config.serverURI + '/saledate/findAll')
				.then(response => {
					console.log('salesdd@@@@ => ', response.data)

					this.saleDates = response.data
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSeasons () {
			http.get(config.serverURI + '/seasons/findAll')
				.then(response => {
					console.log('sal= => ', response.data)
					response.data.forEach(x => {
						this.seasons.push(x.season)
					})
					// this.saleDates = response.data
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		updateSaleDate () {
			this.update_loader = true
			console.log('one - ', this.sale_id)
			console.log('two - ', this.sale_date)
			const url = config.serverURI + '/saledate/updateSaleDate?id=' + this.sale_id + '&saleDate=' + this.sale_date
			axios.put(url)
				.then(response => {
					const message = response.data.body.message
					console.log('timer44', message)
					this.update_loader = false
					this.editSaleDialog = false
					if (message === 'Success') {
						this.sale_date = ''
						this.getSaleDates()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully updated sale date'
						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = message
				})
				.catch(error => {
					this.editSaleDialog = false
					this.update_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
		},
		approveRejectDefaultSlaShowDialog (item, status) {
			console.log(item)
			console.log(status)
			this.approveStatus = status
			this.sale_id = item.id
			this.approveRejectSaleDialog = true
		},
		submitSale () {
			console.log('this.sale')
			if (this.sale_number < 0 || this.sale_number > 52) {
				return
			} else if (this.sale_interval < 0 || this.sale_interval > 365) {
				return
			} else if (this.sale_start_date === '' || this.sale_end_date === '') {
				alert('Please select start and end dates')
				return
			}

			let passValidation = true
			if (this.saleDates.length !== 0) {
				for (const x of this.saleDates) {
					console.log('sale date , ', x)
					console.log('sale date , ', x.saleDate)
					if ((x.saleNumber === this.sale_number && x.season === this.sale_season) || (x.saleDate === this.sale_start_date)) {
						this.snackbar = true
						this.snackbarColor = 'error'
						this.message = 'Duplicate sale number/season or sale date'
						passValidation = false
						break
					}
				}
			}

			if (!passValidation) {
				return
			}

			this.create_loader = true
			const url = config.serverURI + '/saledate/save?saleNumber=' + this.sale_number + '&season=' + this.sale_season + '&startDate=' + this.sale_start_date + '&endDate=' + this.sale_end_date + '&interval=' + this.sale_interval
			axios.post(url)
				.then(response => {
					const message = response.data.body.message
					console.log('timer44', message)
					this.create_loader = false
					if (message === 'Success') {
						this.sale_number = ''
						this.seasons.length = 0
						this.sale_season = ''
						this.sale_interval = ''
						this.sale_start_date = ''
						this.sale_end_date = ''
						this.getSaleDates()
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.message = 'Successfully added sale date'
						return
					}
					this.snackbar = true
					this.snackbarColor = 'error'
					this.message = 'Problem adding sale date'
				})
				.catch(error => {
					this.create_loader = false
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
		},
		validateSaleNumber () {
			const saleValue = parseInt(this.sale_number)
			if (isNaN(saleValue) || saleValue < 1 || saleValue > 52) {
				this.saleNumberErrorMessages = [
					'Sale Number Should be between 1 to 52'
				]
			} else {
				this.saleNumberErrorMessages = []
			}
		},
		validateStartDate () {
			const seasonValue = this.sale_season
			console.log(new Date())
			if (seasonValue.length !== 9) {
				this.seasonErrorMessages = ['The season should be in the format YYYY/YYYY ']
			} else {
				this.startDateErrorMessages = []
			}
		},
		validateInterval () {
			const interval = parseInt(this.sale_interval)
			if (isNaN(interval) || interval < 1 || interval > 365) {
				this.intervalErrorMessages = [
					'The interval should be between 1 and 365 '
				]
			} else {
				this.intervalErrorMessages = []
			}
		},
		validateEndDate () {
			const chargeValue = parseInt(this.sale_number)
			if (isNaN(chargeValue) || chargeValue < 5) {
				this.endDateErrorMessages = [
					'Rate must be a number greater or equal to 0 '
				]
			} else {
				this.endDateErrorMessages = []
			}
		},
		formatDate (timestamp) {
			const date = new Date(timestamp)
			return date.toLocaleDateString() // Formats date to a string in mm/dd/yyyy format
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn{
  padding: 10px;
  margin: 5px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col{
  border: 1px solid brown;
}
</style>
